// src/components/clients/clientsData.js
export const CLIENTS = [
  {
    id: "san-rafael",
    name: "Clínica San Rafael (Steward Colombia)",
    sector: "Salud",
    logo: "/assets/logos/Steward.png",
    summary:
      "Intervenciones en áreas críticas (UCI, urgencias, hospitalización y servicios).",
    bullets: [
      "Ampliación/modificación de espacios arquitectónicos.",
      "Ampliación/modificación de redes hidrosanitarias.",
      "Instalación de redes eléctricas especiales.",
      "Cielorrasos en drywall.",
      "Pintura de alta asepsia.",
      "Enchapes para residuos peligrosos y filtros de acceso."
    ]
  },
  {
    id: "centenario",
    name: "Clínica El Centenario (Steward Colombia)",
    sector: "Salud",
    logo: "/assets/logos/Steward.png",
    summary:
      "Cielorrasos y mantenimiento de acabados con pintura de asepsia en áreas críticas.",
    bullets: [
      "Ampliación y modificación de redes hidrosanitarias.",
      "Instalación de redes eléctricas especiales.",
      "Enchapes y pintura de asepsia en áreas vitales.",
      "Reparaciones locativas.",
      "Atención de emergencias (redes/infiltraciones).",
      "Cielorraso en drywall para lobby."
    ]
  },
  {
    id: "bancamia",
    name: "Bancamía",
    sector: "Financiero",
    logo: "/assets/logos/bancamia.png",
    summary:
      "Mantenimientos generales a oficinas a nivel nacional.",
    bullets: [
      "Speed en puertas de ingreso.",
      "Mantenimientos de redes eléctricas.",
      "Destaponamientos y mantenimiento sanitario.",
      "Mantenimiento de UPC.",
      "Redes de voz y datos.",
      "Suministro/ajuste de mobiliario, pintura interior/exterior.",
      "Mantenimiento de plantas eléctricas y adecuaciones de cielorraso."
    ]
  },
  {
    id: "maristas",
    name: "Comunidad Hermanos Maristas",
    sector: "Educación",
    logo: "/assets/logos/hermanos.png",
    summary:
      "Mantenimiento integral de infraestructura institucional.",
    bullets: [
      "Techos, puertas, pisos y jardines.",
      "Mantenimiento eléctrico, nuevos puntos y luminarias.",
      "Resanes y pintura, cambio de enchapes.",
      "Trabajo en alturas y cambio de cubiertas.",
      "Particiones, mallas de cerramiento.",
      "Retiro de humedades y ampliación de espacios."
    ]
  },
  {
    id: "caman",
    name: "CAMAN S.A.S",
    sector: "Industrial",
    logo: "/assets/logos/camman.png",
    summary: "Mantenimientos y adecuaciones locativas.",
    bullets: [
      "Reparaciones/arreglos locativos.",
      "Obra civil y pintura.",
      "Mantenimientos eléctricos."
    ]
  },
  {
    id: "makariza",
    name: "MAKARIZA",
    sector: "Industria",
    logo: "/assets/logos/maka.png",
    summary: "Mantenimientos preventivos y correctivos.",
    bullets: [
      "Redes eléctricas e hidrosanitarias.",
      "Mantenimientos de acabados en áreas de la compañía."
    ]
  },
  
  {
    id: "gesticobranzas",
    name: "Gesticobranzas S.A.S",
    sector: "Servicios",
    logo: "/assets/logos/gesti.png",
    summary: "Soporte integral a oficinas y TI.",
    bullets: [
      "Mantenimiento de puestos de trabajo y mobiliario.",
      "Mantenimiento eléctrico, luminarias y nuevos puntos.",
      "Resanes y pintura; enchapes sobre piso.",
      "Administración de red y aplicativos.",
      "Mantenimiento y administración de control de acceso."
    ]
  },
  {
    id: "isimo",
    name: "Ísimo",
    sector: "Retail",
    logo: "/assets/logos/Ísimo_logo.png",
    summary: "Adecuación integral de puntos de venta a nivel nacional, incluyendo obra civil y la modernización de sistemas eléctricos para optimizar la operación comercial.",
    bullets: [
      "Adecuación de locales comerciales según layout de la marca.",
      "Instalación de redes eléctricas reguladas y de uso general.",
      "Implementación de sistemas de iluminación LED de bajo consumo.",
      "Obra civil menor para puntos de pago y áreas de almacenamiento.",
      "Canalizaciones para redes de voz, datos y sistemas de seguridad.",
      "Certificación de instalaciones eléctricas bajo norma RETIE."
    ]
  }
  
];
